<div class="row" *ngIf="job">
    <div class="col-xs-12">
        <div class="main-box clearfix">
            <header class="main-box-header clearfix col-xs-offset-1 col-xs-10 text-center" *ngIf="step3Error?.hasErrorFlag">
                <h2 class="has-error">
                    <span class="help-block">
                        <em>*</em> {{step3Error?.errorMessage}}
                    </span>
                </h2>
            </header>
            <div class="row" style="padding-bottom: 35px; margin-top: 10px;">
                <div class="col-xs-12 emerald" style="padding: 15px; padding-left: 30px;">
                    <h2>
                        <strong>Scoring and Matching</strong>
                    </h2>
                </div>
                <div class="col-xs-11 col-xs-offset-1">
                    <div class="row" style="padding-top: 15px;">
                        <div class="col-xs-4 checkbox-nice" style="margin-top: 30px">
                            <input type="checkbox" id="select4dot5IntelligenceScore" value="true" checked disabled="true"/>
                            <label class="license-pref-label" for="select4dot5IntelligenceScore">{{intelligencePreferences?.name}}</label>
                        </div>
                        <div class="col-xs-8">
                            <div class="row">
                                <div class="col-xs-7 col-xs-offset-1">
                                    <div>
                                        <div>
                                            <span style="margin-left: {{job.score}}%">
                                                <strong>{{job.score}}&nbsp;</strong>
                                                <span *ngIf="intelligencePreferences?.company" [title]="intelligencePreferences?.company">[{{intelligencePreferences?.company}}]</span>
                                            </span>
                                        </div>
                                        <div>
                                            <span style="font-size: 20px;margin-top: -24px; margin-left: {{job.score}}%" class="fa fa-caret-down"></span>
                                        </div>
                                    </div>
                                    <div class="slider-intelligence slde3 markerSliderGap">
                                        <label class="pull-left" style="padding-top: 12px;font-size:inherit;">0</label>
                                        <label class="pull-right" style="padding-top: 12px; margin-right: -5px;font-size:inherit;">100</label>
                                    </div>
                                    <span class="slider-label" id="4dot5IntelligenceScoreDisplayValue" style="padding-left: 26%;"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 15px;" *ngIf="autoMatchingPreferences?.enabled">
                        <div class="col-xs-12 checkbox-nice">
                            <input type="checkbox" id="selectAutoMatching" [(ngModel)]="job.autoMatch"
                                   [ngModelOptions]="{standalone: true}" [disabled]="!autoMatchingPreferences?.enabled"/>
                            <label class="license-pref-label" for="selectAutoMatching">
                                {{autoMatchingPreferences?.name}} (When this is enabled, the Requisition is available for automated candidate matching.)
                                <span *ngIf="autoMatchingPreferences?.message !== null">
                                    ({{autoMatchingPreferences?.message}})
                                </span>
                            </label>
                        </div>
                    </div>
                    <div class="row pt-3 ml-5" *ngIf="autoMatchingPreferences?.enabled">
                        <div class="col-xs-12 checkbox-nice">
                            <input type="checkbox" id="missingPreferencedetails" [(ngModel)]="job.includeCandidatesMatchingMandatoryCriteria"
                                [ngModelOptions]="{standalone: true}" />
                            <label class="license-pref-label" for="missingPreferencedetails">
                                <span>Only include candidates matching mandatory <b>skills/education</b> criteria <span class="text-danger">(strict)</span></span>
                            </label>
                        </div>
                    </div>
                    <div class="row pt-3 ml-5" *ngIf="autoMatchingPreferences?.enabled">
                        <div class="col-xs-12 checkbox-nice">
                            <input type="checkbox" id="candidatesAdditionalDetails" [(ngModel)]="job.includeCandidatesWithNoAdditionalDetails"
                                [ngModelOptions]="{standalone: true}" />
                            <label class="license-pref-label" for="candidatesAdditionalDetails">
                                <span>Also include candidates with <b>missing preference</b> details <span class="text-success">(lenient)</span></span>
                            </label>
                        </div>
                    </div>
                    <div class="row ml-5" style="padding-top: 15px;" *ngIf="!autoMatchingPreferences?.enabled">
                        <div class="col-xs-12">
                            Matching candidates to this Requisition is a manual process only.
                        </div>
                    </div>
                    <div class="row ml-5" style="padding-top: 15px;" *ngIf="autoMatchingPreferences?.enabled">
                        <div class="col-xs-12">
                            Note: Manual Match is always available.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main-box clearfix" style="min-height: 200px;">
            <div class="row" style="padding-bottom: 35px; margin-top: 10px;">
                <div class="col-xs-12 emerald" style="padding: 15px; padding-left: 30px;">
                    <h2>
                        <strong>Workflow Steps</strong>
                    </h2>
                </div>
                <div class="col-xs-11 col-xs-offset-1">
                    <div class="row" style="padding-top: 15px;">
                        <div class="col-xs-12 checkbox-nice">
                            <input type="checkbox" id="select4dot5RecruiterScreening"
                                   [(ngModel)]="job.recruiterScreening" [ngModelOptions]="{standalone: true}"
                                   [disabled]="!recruiterScreeningPreferences?.enabled || disableWorkflowSettings"
                                   (ngModelChange)="onStepSelectionChange(job.recruiterScreening, recruiterScreeningPreferences)"/>
                            <label class="license-pref-label" for="select4dot5RecruiterScreening" [class.license-pref-label-disabled]="!recruiterScreeningPreferences?.enabled || disableWorkflowSettings">
                                {{recruiterScreeningPreferences?.name}}
                                <span *ngIf="recruiterScreeningPreferences?.message !== null">
                                    ({{recruiterScreeningPreferences?.message}})
                                </span>
                            </label>
                        </div>
                    </div>

                    <div class="row" style="padding-top: 15px;">
                        <div class="col-xs-4 checkbox-nice" style="display:flex">
                            <input type="checkbox" id="select4dot5TechAssessment" [(ngModel)]="job.techAssessment"
                                   [ngModelOptions]="{standalone: true}"
                                   (ngModelChange)="onStepSelectionChange(job.techAssessment, techAssessmentPreferences)"
                                   [disabled]="!techAssessmentPreferences?.enabled || disableWorkflowSettings"/>
                            <label class="license-pref-label" for="select4dot5TechAssessment" [class.license-pref-label-disabled]="!techAssessmentPreferences?.enabled || disableWorkflowSettings">
                                {{techAssessmentPreferences?.name}}
                                <span *ngIf="techAssessmentPreferences?.message !== null">
                                    ({{techAssessmentPreferences?.message}})
                                </span>
                                <span *ngIf="!techAssessmentPreferences?.message && (!techAssessmentList || techAssessmentList.length == 0)">
                                    (Assessments are not assigned for the <span>{{isCorporate ? 'BU' : 'Client'}}</span>)
                                </span>
                            </label>
                        </div>
                        <div class="col-xs-8">
                            <div class="row">
                                <div class="col-xs-7 col-xs-offset-1">
                                    <div class="form-group" [class.has-error]="step3Submitted && (techAssessmentPreferences?.enabled && job.techAssessment) && !job.techAssessmentId">
                                        <select class="form-control" id="techAssessments"
                                                [(ngModel)]="job.techAssessmentId" [ngModelOptions]="{standalone: true}"
                                                [disabled]="!(techAssessmentPreferences?.enabled && job.techAssessment) || disableWorkflowSettings"
                                                (ngModelChange)="onAssessmentChange('Technical')"
                                                style="margin-bottom: 10px; width: 55%;border-width: 1px;">
                                            <option *ngFor="let techAssessment of techAssessmentList; trackBy: trackByIndex" [value]="techAssessment.assessmentId" [title]="techAssessment.testName">{{techAssessment.testName}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-4">
                            <span class="threshold-score-label">Threshold Score</span>
                        </div>
                        <div class="col-xs-8">
                            <div class="col-xs-7 col-xs-offset-1">
                                <div>
                                    <div>
                                        <span style="margin-left: {{job.techAssessmentScore}}%">
                                            <strong>{{job.techAssessmentScore}}&nbsp;</strong>
                                            <span *ngIf="techAssessmentPreferences?.company" [title]="techAssessmentPreferences?.company">[{{techAssessmentPreferences?.company}}]</span>
                                        </span>
                                    </div>
                                    <div>
                                        <span style="font-size: 20px;margin-top: -24px; margin-left: {{job.techAssessmentScore}}%" class="fa fa-caret-down"></span>
                                    </div>
                                </div>
                                <div class="slider-tech-assessment slde3 markerSliderGap">
                                    <label class="pull-left" style="padding-top: 12px;font-size:inherit;">0</label>
                                    <label class="pull-right" style="padding-top: 12px; margin-right: -5px;font-size:inherit;">100</label>
                                </div>
                                <span class="slider-label" id="techAssessmentScoreDisplayValue" style="padding-left: 26%;"></span>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 15px;">
                        <div class="col-xs-4 checkbox-nice" style="margin-top: 20px;display:flex">
                            <input type="checkbox" id="select4dot5ValueAssessment"
                                   [(ngModel)]="job.valueAssessment" [ngModelOptions]="{standalone: true}"
                                   [disabled]="!valueAssessmentPreferences?.enabled || disableWorkflowSettings"
                                   (ngModelChange)="onStepSelectionChange(job.valueAssessment, valueAssessmentPreferences)" />
                            <label class="license-pref-label" for="select4dot5ValueAssessment" [class.license-pref-label-disabled]="!valueAssessmentPreferences?.enabled || disableWorkflowSettings">
                                {{valueAssessmentPreferences?.name}}
                                <span *ngIf="valueAssessmentPreferences?.message !== null">
                                    ({{valueAssessmentPreferences?.message}})
                                </span>
                            </label>
                        </div>
                        <div class="col-xs-8">
                            <div class="row">
                                <div class="col-xs-7 col-xs-offset-1">
                                    <div class="form-group" [class.has-error]="step3Submitted && (valueAssessmentPreferences?.enabled && job.valueAssessment) && !job.valueAssessmentId">
                                        <select class="form-control" id="valueAssessments"
                                                [(ngModel)]="job.valueAssessmentId" [ngModelOptions]="{standalone: true}"
                                                [disabled]="!(valueAssessmentPreferences?.enabled && job.valueAssessment) || disableWorkflowSettings"
                                                style="margin-bottom: 10px; width: 55%;margin-top: 15px;border-width: 1px;"
                                                (ngModelChange)="onAssessmentChange('Value')">
                                            <option *ngFor="let valueAssessment of valueAssessmentList; trackBy: trackByIndex" [value]="valueAssessment.assessmentId" [title]="valueAssessment.testName">{{valueAssessment.testName}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 15px;">
                        <div class="col-xs-4" style="padding-left: 32px;">
                            <label class="license-pref-label">Verification</label>
                        </div>
                    </div>
                    <div class="row" style="padding-left: 65px; padding-top: 10px;">
                        <div class="col-xs-12 checkbox-nice">
                            <input type="checkbox" id="select4dot5EducationVerification" [(ngModel)]="job.eduVerification"
                                   [ngModelOptions]="{standalone: true}"
                                   (ngModelChange)="onStepSelectionChange(job.eduVerification, verificationPreferences, 'Education Verification')"
                                   [disabled]="!verificationPreferences?.educationVerificationEnabled || disableWorkflowSettings"/>
                            <label class="license-pref-label" for="select4dot5EducationVerification" [class.license-pref-label-disabled]="!verificationPreferences?.educationVerificationEnabled || disableWorkflowSettings">
                                {{verificationPreferences?.educationVerificationName}}
                                <span *ngIf="verificationPreferences?.educationVerificationMessage !== null">
                                    ({{verificationPreferences?.educationVerificationMessage}})
                                </span>
                            </label>
                        </div>
                    </div>
                    <div class="row" style="padding-left: 65px; padding-top: 10px;">
                        <div class="col-xs-12 checkbox-nice">
                            <input type="checkbox" id="select4dot5ExperienceVerification" [(ngModel)]="job.expVeification"
                                   [ngModelOptions]="{standalone: true}"
                                   [disabled]="!verificationPreferences?.experienceVerificationEnabled || disableWorkflowSettings"
                                   (ngModelChange)="onStepSelectionChange(job.expVeification, verificationPreferences, 'Experience Verification')"/>
                            <label class="license-pref-label" for="select4dot5ExperienceVerification" [class.license-pref-label-disabled]="!verificationPreferences?.experienceVerificationEnabled || disableWorkflowSettings">
                                {{verificationPreferences?.experienceVerificationName}}
                                <span *ngIf="verificationPreferences?.experienceVerificationMessage !== null">
                                    ({{verificationPreferences?.experienceVerificationName}})
                                </span>
                            </label>
                        </div>
                    </div>

                    <div class="row" style="padding-top: 15px;">
                        <div class="col-xs-12 checkbox-nice">
                            <input type="checkbox" id="select4dot5PhoneScreen" [(ngModel)]="job.phoneScreen"
                                   [ngModelOptions]="{standalone: true}"
                                   [disabled]="!phoneScreenPreferences?.enabled || disableWorkflowSettings"
                                   (ngModelChange)="onStepSelectionChange(job.phoneScreen, phoneScreenPreferences)"/>
                            <label class="license-pref-label" for="select4dot5PhoneScreen" [class.license-pref-label-disabled]="!phoneScreenPreferences?.enabled || disableWorkflowSettings">
                                {{phoneScreenPreferences?.name}}
                                <span *ngIf="phoneScreenPreferences?.message !== null">
                                    ({{phoneScreenPreferences?.message}})
                                </span>
                            </label>
                        </div>
                    </div>

                    <div class="row" style="padding-top: 15px;">
                        <div class="col-xs-12 checkbox-nice">
                            <input type="checkbox" id="select4dot5Interview" [(ngModel)]="job.interview"
                                   [ngModelOptions]="{standalone: true}"
                                   [disabled]="!interviewPreferences?.enabled || disableWorkflowSettings"
                                   (ngModelChange)="onStepSelectionChange(job.interview, interviewPreferences)"/>
                            <label class="license-pref-label" for="select4dot5Interview" [class.license-pref-label-disabled]="!interviewPreferences?.enabled || disableWorkflowSettings">
                                {{interviewPreferences?.name}}
                                <span *ngIf="interviewPreferences?.message !== null">
                                    ({{interviewPreferences?.message}})
                                </span>
                            </label>
                        </div>
                    </div>

                </div>
            </div>
            <div class="row" style="padding-bottom: 35px; margin-top: 10px;">
                <div class="col-xs-12 emerald"
                    style="padding: 15px; padding-left: 30px;">
                    <h2>
                        <strong>Steps Order</strong>
                    </h2>
                </div>
                <div class="col-xs-11 col-xs-offset-1">
                    <div class="row" *ngIf="isAnyWorkflowStepsEnabled"
                        style="margin-top:1em;">
                        <div class="col-xs-10 text-center">
                            <span style="color:grey">
                                Drag and Drop the Steps to Change Order
                                <span *ngIf="candidatesPresentOnJob">(Cannot change the step order as candidate(s) exist in the Requisition) </span>
                            </span>
                        </div>
                        <div class="col-xs-10 steps-wrapper"
                            style="display:flex; margin-top:1em">
                            <div class="dnd-step-box-key col-xs-2">
                                <span>{{selectedJobType}}:</span>
                            </div>
                            <div style="display:flex" class="col-xs-10 workflow-steps-settings-dnd">
                                <!-- First step -->
                                <div class="text-center dnd-step-box"
                                    *ngIf="workflowStepsOrder[selectedJobType] && workflowStepsOrder[selectedJobType][0]?.enabled"
                                    [class.license-pref-label-disabled]="disableWorkflowSettings || candidatesPresentOnJob"
                                    style="background-color:#d3d3d342">
                                    <span>{{workflowStepsOrder[selectedJobType][0].stepName}}</span>
                                </div>
                                <div cdkDropList [cdkDropListDisabled]="disableWorkflowSettings || candidatesPresentOnJob"
                                    (cdkDropListDropped)="onStepDropped($event)"
                                    [class.license-pref-label-disabled]="disableWorkflowSettings || candidatesPresentOnJob"
                                    style="display:flex">
                                    <div class="text-center dnd-step-box"
                                        *ngFor="let step of workflowStepsOrderToRender[selectedJobType]; trackBy: trackByStepId"
                                        cdkDrag [cdkDragDisabled]="disableWorkflowSettings || candidatesPresentOnJob">
                                        <div>{{step.stepName}}</div>
                                    </div>
                                </div>
                                <!-- last step -->
                                <div class="text-center dnd-step-box"
                                    [class.license-pref-label-disabled]="disableWorkflowSettings || candidatesPresentOnJob"
                                    *ngIf="workflowStepsOrder[selectedJobType] && workflowStepsOrder[selectedJobType][workflowStepsOrder[selectedJobType].length-1]?.enabled"
                                    style="background-color:#d3d3d342">
                                    <span>{{workflowStepsOrder[selectedJobType][workflowStepsOrder[selectedJobType].length-1].stepName}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="main-box clearfix">
            <div class="row" style="padding-bottom: 35px; margin-top: 10px;">
                <div class="col-xs-12 emerald" style="padding: 15px; padding-left: 30px;">
                    <h2>
                        <strong>Assessments</strong>
                    </h2>
                </div>
                <div class="col-xs-11 col-xs-offset-1">
                    <div class="row" style="padding-top: 15px;">
                        <div class="col-xs-12 checkbox-nice">
                            <input type="checkbox" id="select4dot5ImageProctoring" [(ngModel)]="job.imageProctoring"
                                   [ngModelOptions]="{standalone: true}"
                                   [disabled]="!imageProctoringPreferences?.enabled" (ngModelChange)="onImageProctoringCheckboxClick()" />
                            <label class="license-pref-label" for="select4dot5ImageProctoring" [class.license-pref-label-disabled]="!imageProctoringPreferences?.enabled">
                                {{imageProctoringPreferences?.name}}
                                <span *ngIf="imageProctoringPreferences?.message != null">
                                    ({{imageProctoringPreferences?.message}})
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-xs-11 col-xs-offset-1">
                    <div class="row" style="padding-top: 10px; padding-left:65px;">
                        <div class="col-xs-12 checkbox-nice">
                            <input type="checkbox" id="select4dot5AddProctoringImagesToReport" [(ngModel)]="job.addProctoringImagesToReport"
                                   [ngModelOptions]="{standalone: true}"
                                   [disabled]="!imageProctoringPreferences?.enabled || !job.imageProctoring || !addImagesToReportPreferences?.enabled" />
                            <label class="license-pref-label" for="select4dot5AddProctoringImagesToReport" [class.license-pref-label-disabled]="!imageProctoringPreferences?.enabled || !job.imageProctoring || !addImagesToReportPreferences?.enabled">
                                {{addImagesToReportPreferences?.name}}
                                <span *ngIf="addImagesToReportPreferences?.message !== null">
                                    ({{addImagesToReportPreferences?.message}})
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
